var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurServiceSectionLeftSideUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0937493 0L0.09375 16L17.0938 16L17.0937 -7.43094e-07L0.0937493 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_372)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3991 6.529L8.59406 1.724L3.78906 6.529L4.73206 7.471L7.92706 4.276L7.92706 14L9.26106 14L9.26106 4.276L12.4561 7.471L13.3991 6.529Z",
    fill: "#357960"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurServiceSectionLeftSideUpIcon);
export default __webpack_public_path__ + "static/media/our_service_section_left_side_up_icon.871d8d86dd06a7f200f40c46edfb4c01.svg";
export { ForwardRef as ReactComponent };